export const MapMarkerIcon = ({ color = "blue", size = 42 }) => (
  <svg
    viewBox="0 0 32 32"
    width={size}
    height={size}
    style={{
      display: "block",
      filter: "drop-shadow(0 1px 3px rgba(0,0,0,0.5))",
    }}
    className={`text-${color}`}
  >
    <path
      d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7z"
      fill="currentColor"
      fillOpacity="0.75"
    />
    <path
      d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7z"
      fill="none"
      stroke="white"
      strokeWidth="2"
    />
    <circle cx="12" cy="9" r="2.5" fill="white" />
  </svg>
);
